import * as Yup from "yup";

const dt = new Date();

export const schemaEntityManagement = Yup.object().shape({
  name: Yup.string()
    .min(3, "Entity name must be at least 3 characters long")
    .required("Entity name is a required field"),
  phone: Yup.string()
    .min(13, "Phone field is wrong")
    .max(16, "Phone field is wrong")
    .required("Phone is a required field"),
  address: Yup.string().required("Address is a required field"),
  email: Yup.string().email().required("Email is a required field"),
  startContract: Yup.date()
    .max(
      dt,
      "The start date of the contract cannot be greater than the current date."
    )
    .typeError("Enter a valid date for the start of the contract"),
  endContract: Yup.date().typeError(
    "Enter a valid date for the end of the contract"
  ),
});
